import { lazy, Suspense } from "react";
import { useParams } from "react-router-dom";

const AiAssistant = lazy(() =>
    import("@me8eon/new-ai").then((module) => ({
        default: module.AiAssistant,
    }))
);

interface AiPageProps {
    /** `/new-ai/shared#<token>`: open a chat someone shared, read-only. */
    shared?: boolean;
}

export const AiPage = ({ shared = false }: AiPageProps) => {
    const { threadId } = useParams<{ threadId?: string }>();

    return (
        <main>
            <Suspense fallback={<div>Loading AI Assistant...</div>}>
                <AiAssistant threadId={shared ? undefined : threadId} shared={shared} />
            </Suspense>
        </main>
    );
};
